import { FormattedMessage } from 'react-intl';
import { Box, Button, Stack, Typography } from '@mui/material';
import { SubSection } from '@ui-framework/index';

function WrapWithQuestion({
  useCurrenSPQuestionAnswered = false,
  setUseCurrenSPQuestionAnswered,
  wizardRef,
  children,
}) {
  if (!useCurrenSPQuestionAnswered) {
    return (
      <Box>
        <SubSection>
          <Box sx={{ textAlign: 'center', mt: 2, mb: 4 }}>
            <Typography variant="body">
              <FormattedMessage
                id="DO_YOU_WANT_TO_RESCHEDULE_WITH_CURRENT_SERVICE_PROVIDER"
                defaultMessage="Do you want to reschedule with current service provider?"
              />
            </Typography>
          </Box>
          <Box>
            <Stack
              spacing={2}
              direction="row"
              sx={{ justifyContent: 'center' }}>
              <Button
                variant="contained"
                onClick={() => setUseCurrenSPQuestionAnswered(true)}>
                <FormattedMessage id="YES" defaultMessage="Yes" />
              </Button>
              <Button
                variant="outlined"
                onClick={() => {
                  setUseCurrenSPQuestionAnswered(true);
                  wizardRef.current.next();
                }}>
                <FormattedMessage
                  id="NO_SHOW_ME_NEXT_OPTION"
                  defaultMessage="No, show me next option"
                />
              </Button>
            </Stack>
          </Box>
        </SubSection>
      </Box>
    );
  }
  return children;
}

export default WrapWithQuestion;
